import React from 'react'
import { Container } from './container'
import auth from '../utils/auth'

const PageHeader = ({ title, description, image, className }) => {
  const { isOfficial, isVerified } = auth()

  const length = description ? description.split(" ").length : 0
  const fontSize = length <= 10 ? 'text-lg' : 'text-sm'

  return (
    <Container
      className={`page-header ${isOfficial ? 'official' : isVerified ? 'verified' : ''} py-5 md:py-8 ${className}`}
      color="#f5f5f5"
    >
      <div className="flex flex-col md:flex-row items-center">
        <div className="w-full md:w-7/12 order-2 md:order-1">
          <h1 className="text-center md:text-left text-3xl md:text-5xl font-bold md:mb-2 leading-tight md:leading-normal uppercase">{title}</h1>
          <p className={`hidden md:block text-gray-600 pr-4 ${fontSize}`}>{description}</p>
        </div>
        <div className="w-4/12 md:w-5/12 mb-5 md:mb-0 order-1 md:order-2">
          <img src={image} alt="" className="mx-auto" style={{maxHeight: '270px'}} />
        </div>
      </div>
    </Container>
  )
}

export { PageHeader }
